import { projectToCRS } from "@nova/calculate-geospatial"
import { Point } from "@nova/data-create-polygon-kml"
import { FeatureCollection } from "geojson"
export const lineTransformer = (
    lines: { name: string; points: Point[] }[],
    projection?: string
) => {
    const json = { type: "FeatureCollection", features: [] } as FeatureCollection
    lines.forEach((line) => {
        json.features.push({
            type: "Feature",
            geometry: {
                type: "LineString",
                coordinates: line.points.map((point) =>
                    projectToCRS([point[0], point[1]], projection)
                ),
            },
            properties: {
                id: line.name,
            },
        })
    })
    return json
}
